import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import { useMemo } from "react";
import useLibrary from "../../modules/user/hooks/use-library";
import sanitazeHTML from 'sanitize-html';
import '../../../node_modules/quill/dist/quill.core.css'
import logoSrc from '../../assets/logo.jpg';
import './style.scss';

type Props = {
    libraryCode: string
}

const defaultIntro = `
    <div>
        <h2>Cześć!</h2>
        <p>
        Wcześniej zostaliście powitani przez organizatorów gry, a teraz wita Was Wasza lokalna biblioteka! Cieszymy się, że zainteresowała Was nasza gra. Wykonanie niektórych zadań wymaga odwiedzenia nas i bardzo cieszymy się na te odwiedziny! Nasze drzwi są dla Was otwarte!
        </p>
        <p style="text-align: right">
        Życzymy powodzenia!
        </p>
    </div>
`;

const Welcome: React.FC<Props> = ({ libraryCode }) => {

    const { library, isLoading } = useLibrary(libraryCode);

    const introDelta = useMemo(() => {
        try {
            return JSON.parse(library?.intro || '[]');
        } catch (e) {

        }

        return { ops: [] };
    }, [library]);

    const intro = useMemo(() => {
        const parser = new QuillDeltaToHtmlConverter(introDelta.ops, {
            inlineStyles: true
        });



        return sanitazeHTML(parser.convert() || defaultIntro, {
            allowedTags: [
                "address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4",
                "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div",
                "dl", "dt", "figcaption", "figure", "hr", "li", "main", "ol", "p", "pre",
                "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn",
                "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp",
                "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption",
                "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr"
            ],
            disallowedTagsMode: 'discard',
            allowedAttributes: {
                a: ['href', 'name', 'target'],
                // We don't currently allow img itself by default, but this
                // would make sense if we did. You could add srcset here,
                // and if you do the URL is checked for safety
                img: ['src'],
                p: ['class', 'style']
            },
            // Lots of these won't come up by default because we don't allow them
            selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
            // URL schemes we permit
            allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel'],
            allowedSchemesByTag: {},
            allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
            allowProtocolRelative: true,
            enforceHtmlBoundary: false
        });
    }, [introDelta])

    const imageSrc = useMemo(() => {
        return library?.imageUrl || logoSrc;
    }, [library]);


    return <div className="welcome-page">
        {!isLoading && <div className="intro">
            <img src={imageSrc} alt='logo' />
            <div className="intro-content" dangerouslySetInnerHTML={{ __html: intro }}></div>
        </div>}
    </div>
}

export default Welcome;
